<!--
 * @Author: cryi.liu
 * @Date: 2020-06-15 14:55:38
 * @LastEditTime: 2020-06-16 12:25:35
 * @Description: 审批拒绝评论处理函数
-->
<template>
  <i-modal
    class="reject-comment-modal"
    :value="modalShow"
    :loading="modalLoading"
    :mask-closable="false"
    title="说明"
    @on-visible-change="modalVisibleChangeHandler"
    @on-ok="modalClickOkHandler">
    <i-input type="textarea" :value="comment" :rows="4" @on-change="commentInputChangeHandler" />
  </i-modal>
</template>

<script>
import axios from 'axios';

export default {
  name: 'RejectCommentModal',
  props: {
    modalShow: { type: Boolean, required: true },
    approveId: { type: [Number, String], required: true },
    springMvcToken: { type: String, required: true },
  },
  data() {
    return {
      modalLoading: true,
      comment: '',
    };
  },
  methods: {
    /**
     * 模态框显示状态改变处理函数
     */
    modalVisibleChangeHandler(status) {
      if (!status) {
        this.$emit('close-modal');
      }
    },
    /**
     * 评论说明框内容变化
     */
    commentInputChangeHandler(e) {
      this.comment = e.target.value;
    },
    /**
     * 模态框点击ok处理函数
     */
    modalClickOkHandler() {
      this.requestRefuseApprovalAndSetting();
    },
    requestRefuseApprovalAndSetting() {
      this.requestRefuseApproval()
        .then(() => {
          alert('提交成功！');
          this.$emit('close-modal');
          this.comment = '';
          window.location.href = document.referrer;
        })
        .catch(() => {
          alert('提交失败，请联系管理员！');
        });
    },
    requestRefuseApproval() {
      return new Promise(async (resolve, reject) => {
        const result = await axios.post(`/mvc/exam/approval/reject/${this.approveId}?springMvcToken=${this.springMvcToken}&comments=${this.comment}`);
        if (result.data) {
          resolve(result.data);
        } else {
          reject(result.data);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.reject-comment-modal {
  /deep/ .ivu-input {
    &:focus {
      border-color: #dcdee2;
      box-shadow: none;
    }

    &:hover {
      border-color: #dcdee2;
    }
  }
}
</style>
